<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Edit {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name:table_module}">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Edit</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 grid-margin">
        <componentForm
          :module="module"
          :table_module="table_module"
          :alias_table="alias_table"
          :fields="fields"
        ></componentForm>
      </div>
    </div>
  </div>
</template>

<script>
import componentForm from "@/components/form";
export default {
  data() {
    return {
      module: "Toko",
      table_module: "store",
      alias_table: "str",
      fields: {},
      uuid: this.$route.params.uuid
    };
  },
  components: {
    componentForm
  },
  mounted() {
    this.axios
      .get("/" + this.table_module + "/edit/" + this.uuid)
      .then(response => {
        this.fields = response.data.data;
      }).catch(error => {
        if (error.response) 
        {
          this.$router.push({name : this.table_module})
        } 
        else if (error.request) 
        {
          console.log('Error', error.message);
        } 
        else 
        {
          console.log('Error', error.message);
        }
        
      });
  }
};
</script>